import { Injectable, Inject } from '@angular/core';
import { PackageDependenciesGraph } from './package-dependencies-graph';
import { Config } from '../core/config';

@Injectable()
export class PackageDependenciesService {

  buildGraphContainer(target: Target, pathMaster: Path) {
    const container = new PackageDependenciesGraph();
    let index = -1;
    pathMaster.path.forEach(pathInternal => {
      pathInternal.forEach(pathDetail => {
        const pathDetailRelation = {
          ...pathDetail.relation,
          from: pathDetail.id
        };
        index = container.nodes.findIndex(x => x.id === pathDetail.id);
        if (index === -1) {
          container.nodes.push({
            id: pathDetail.id,
            label: this.getNodeLabel(pathDetail.objectData.displayName, pathDetail.objectData.type),
            type: pathDetail.objectData.displayName
          });
        }
        index = container.links.findIndex(x => x.source === pathDetail.id && x.target === pathDetailRelation.to);
        if (index === -1) {
          container.links.push({
            source: pathDetailRelation.to, target: pathDetailRelation.from,
            label: this.getLinkLabel(pathDetailRelation.type)
          });
        }
      });
    });

    index = container.nodes.findIndex(x => x.id === target.id);
    if (index === -1) {
      container.nodes.push({ id: target.id, type: target.objectData.type, label: target.objectData.displayName });
    }
    return container;
  }

  private getNodeLabel(displayName: string, type: string): string {
    return type;
  }

  private getLinkLabel(type: string): string {
    if (type === 'Reference') {
      return 'USED_BY';
    }
    else if (type === 'Parent') {
      return 'CHILD_OF';
    }
    else if (type === 'Child') {
      return 'PARENT_OF';
    }
    return type;
  }
}
